<template>
    <v-row
        no-gutters
        class="mb-auto"
    >
        <v-col>
            <v-list
                id="emailChain"
                ref="emailChain"
                three-line
                subheader
                class="overflow-y-auto pt-3"
                height="54vh"
                style="border-radius: 0;"
            >
                <!-- Once we have multiple emails in an email chain, we'll need to add something like this -->
                <v-row no-gutters v-if="!threadEmails.length">
                    <div class="mx-auto pa-5 text-center mt-16">
                        <div v-if="threadEmailCount" class="mt-16">
                            <v-progress-circular
                                indeterminate
                                color="primary"
                                class="ml-2 mb-3"
                            />
                            <h4>Loading Thread...</h4>
                        </div>
                        <div v-else class="mt-16">
                            <v-icon x-large>mdi-forum</v-icon>
                            <h4 class="title">There are no messages in this thread</h4>
                        </div>
                    </div>
                </v-row>
                <template v-for="message in threadEmails">
                    <v-list-item :key="message.id+'as'">
                        <v-list-item-avatar>
                            <v-img
                                v-if="message.brand.code != 'other'"
                                alt="sender avatar image"
                                :src="getBrandIconPath(message.brand.name)"
                            />
                            <v-icon
                                v-else
                                color="#00000066"
                            >
                                mdi-account-outline
                            </v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title class="font-weight-bold" v-text="message.from_name">
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="message.body_cleaned">
                                <text-highlight
                                    :queries="searchMode ? [search] : []"
                                    v-html="message.text_html"
                                >
                                </text-highlight>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                                v-else
                                class="grey--text text--lighten-2 py-2"
                                v-text="'Message contains no text.'"
                            />
                            <v-list-item-action>
                                <v-list-item-action-text>
                                    {{ new Date(message.created) | moment("MMMM Do, YYYY") }}
                                </v-list-item-action-text>
                            </v-list-item-action>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider :key="message.id" />
                </template>
            </v-list>
        </v-col>
        <v-col cols="12">
            <vue-editor
                class="messageBox"
                v-model="newMessage"
            ></vue-editor>
            <v-row class="send-button">
                <v-badge
                    color="green"
                    :content="attachements.length"
                    v-if="attachements.length"
                >
                    <v-btn
                        x-small
                        absolute
                        class="attach-btn px-1"
                        dark
                        @click.stop="attachementDialog = true"
                    >
                        <v-icon color="black" large>mdi-attachment</v-icon>
                    </v-btn>
                </v-badge>
                <v-btn
                    dark
                    x-small
                    absolute
                    class="attach-btn px-1"
                    @click.stop="attachementDialog = true"
                >
                    <v-icon color="black" large>mdi-attachment</v-icon>
                </v-btn>
                <v-dialog
                    v-model="attachementDialog"
                    transition="dialog-bottom-transition"
                    max-width="900"
                >
                    <v-card>
                        <v-toolbar
                            color="primary"
                            dark
                        >
                            Attachements
                        </v-toolbar>

                        <v-card-text class="pt-4">
                            <input
                                type="file"
                                id="file"
                                ref="file"
                                :disabled="uploadingAttachement"
                                @change="handleAttachementUpload($event)"
                            />
                        </v-card-text>

                        <v-card-actions>
                            <v-progress-circular
                                v-if="uploadingAttachement"
                                color="primary"
                            ></v-progress-circular>
                        </v-card-actions>
                        <hr>
                        <v-card-text class="pt-4">
                            <v-chip
                                v-for="(attachement, index) in attachements"
                                :key="attachement.name"
                                class="p-5"
                                close
                                color="primary"
                                outlined
                                @click:close="removeAttachement(index)"
                            >
                                {{ attachement.name }}
                            </v-chip>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-btn
                    icon color="primary"
                    class="ml-9"
                    @click="sendEmail(
                        [threadEmail],
                        newMessage,
                        threadEmailId
                    )"
                >
                    <v-icon large>mdi-send</v-icon>
                </v-btn>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    import { VueEditor } from 'vue2-editor';
    import emailSender from '../../mixins/send-email.mixin';

    export default {
        props: {
            // eslint-disable-next-line vue/require-default-prop
            threadEmail: {
                required: true,
                type: String,
            },
            threadEmailId: {
                required: true,
                type: Number,
            },
            threadEmailCount: {
                required: true,
                type: Number,
            },
            threadEmails: {
                required: true,
                type: Array,
            },
            search: {
                required: false,
                default: '',
                type: String,
            },
            searchMode: Boolean,
            onSearch: Boolean,
        },
        mixins: [emailSender],
        components: {
            VueEditor,
        },
        computed: {
            listHeight() {
                if(!this.selected) return '70vh';
                return this.$vuetify.breakpoint.smAndDown ? '60vh' : '52vh';
            },
        },
    };
</script>

<style scoped>
#emailChain::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #181235;
    background-color: #ffffff;
    border-radius: 10px;
}

#emailChain::-webkit-scrollbar {
    width: 10px;
    background-color: #ffffff;
}

#emailChain::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px #181235;
    background-color: #181235;
}

.messageBox {
    background-color: #ffffff;
    margin-top: -55px;
    border: 0;
}

.messageBox >>> .ql-editor {
    height: 80px !important;
    min-height: auto !important;
    width: 92%;
}

.messageBox >>> .ql-formats:nth-child(1),
.messageBox >>> .ql-formats:nth-child(4),
.messageBox >>> .ql-formats:nth-child(6),
.messageBox >>> .ql-formats:nth-child(7),
.messageBox >>> .ql-formats:nth-child(8),
.messageBox >>> .ql-formats:nth-child(9) {
  display: none;
}

@media screen and (max-width: 767px) {
    .messageBox {
        position: absolute;
        width: 100%;
        margin-top: 10px;
    }

    .messageBox >>> .ql-snow.ql-toolbar button {
        width: 26px;
    }
}
.send-button {
    position: absolute;
    bottom: 30px;
    right: 15px;
}

.attach-btn {
    top: -60px;
    transform: rotate(90deg);
    right: 0;
}
</style>
